import PropTypes from "prop-types";

export default PropTypes.shape({ type: PropTypes.string, text: PropTypes.string });
